export default {
    title: "Recomendações do consultor",
    noItems: "Sem recomendações"
}